import { Component } from '@angular/core';


import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrl: './inventory.component.css',
    imports: [
        RouterModule,
    ]
})
export class InventoryComponent {
  

  constructor() {
    // Escucha a los eventos de navegación para ajustar la visualización del contenido principal.
  
  }

 

}
